/** The server may reject a site's access without disclosing its allowed origins. */
export class WidgetAccessDeniedError extends Error {
  constructor() {
    super('This contact form is not available on this website.');
    this.name = 'WidgetAccessDeniedError';
  }
}
